/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ElcoBaseClient } from './ElcoBaseClient';
import moment from 'moment';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class CallsClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    getPreventCall(contractId: string, siteId: string, options: QueryOptions | null): Promise<PagedDataDtoOfPreventCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/prevent/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPreventCall(_response);
        });
    }

    protected processGetPreventCall(response: AxiosResponse): Promise<PagedDataDtoOfPreventCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfPreventCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfPreventCallDto | null>(<any>null);
    }

    getCorrectionCall(contractId: string, siteId: string, options: QueryOptions | null): Promise<PagedDataDtoOfCorrectionCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/correction/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCorrectionCall(_response);
        });
    }

    protected processGetCorrectionCall(response: AxiosResponse): Promise<PagedDataDtoOfCorrectionCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfCorrectionCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfCorrectionCallDto | null>(<any>null);
    }

    getPlannedMaintenances(contractId: string, siteId: string, options: QueryOptions | null): Promise<PagedDataDtoOfPlannedMaintenanceDto | null> {
        let url_ = this.baseUrl + "/api/Calls/planning/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPlannedMaintenances(_response);
        });
    }

    protected processGetPlannedMaintenances(response: AxiosResponse): Promise<PagedDataDtoOfPlannedMaintenanceDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfPlannedMaintenanceDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfPlannedMaintenanceDto | null>(<any>null);
    }

    getSiteHistoricCall(contractId: string, siteId: string, options: QueryOptions | null): Promise<PagedDataDtoOfHistoricCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/historic/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSiteHistoricCall(_response);
        });
    }

    protected processGetSiteHistoricCall(response: AxiosResponse): Promise<PagedDataDtoOfHistoricCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfHistoricCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfHistoricCallDto | null>(<any>null);
    }

    getSiteObjectHistoricCall(contractId: string, siteId: string, objectId: string, options: QueryOptions | null): Promise<PagedDataDtoOfHistoricCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/historic/{contractId}/{siteId}/{objectId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (objectId === undefined || objectId === null)
            throw new Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSiteObjectHistoricCall(_response);
        });
    }

    protected processGetSiteObjectHistoricCall(response: AxiosResponse): Promise<PagedDataDtoOfHistoricCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfHistoricCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfHistoricCallDto | null>(<any>null);
    }

    getCorrectionCall2(contractId: string, siteId: string, callId: string): Promise<CorrectionCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/correction/{contractId}/{siteId}/{callId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCorrectionCall2(_response);
        });
    }

    protected processGetCorrectionCall2(response: AxiosResponse): Promise<CorrectionCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CorrectionCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CorrectionCallDto | null>(<any>null);
    }

    getPreventCall2(contractId: string, siteId: string, callId: string): Promise<PreventCallDto | null> {
        let url_ = this.baseUrl + "/api/Calls/prevent/{contractId}/{siteId}/{callId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPreventCall2(_response);
        });
    }

    protected processGetPreventCall2(response: AxiosResponse): Promise<PreventCallDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PreventCallDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreventCallDto | null>(<any>null);
    }

    getAllStatus(): Promise<StatusCallDto[] | null> {
        let url_ = this.baseUrl + "/api/Calls/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllStatus(_response);
        });
    }

    protected processGetAllStatus(response: AxiosResponse): Promise<StatusCallDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusCallDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusCallDto[] | null>(<any>null);
    }

    getAllFollowUp(): Promise<FollowUpDto[] | null> {
        let url_ = this.baseUrl + "/api/Calls/followup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllFollowUp(_response);
        });
    }

    protected processGetAllFollowUp(response: AxiosResponse): Promise<FollowUpDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FollowUpDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FollowUpDto[] | null>(<any>null);
    }
}

export class ContractClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    get(options: QueryOptions | null): Promise<PagedDataDtoOfContractDto | null> {
        let url_ = this.baseUrl + "/api/Contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PagedDataDtoOfContractDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfContractDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfContractDto | null>(<any>null);
    }

    getById(contractId: string): Promise<ContractDto | null> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ContractDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ContractDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto | null>(<any>null);
    }

    getAll(): Promise<ContractDto[] | null> {
        let url_ = this.baseUrl + "/api/Contract/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ContractDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto[] | null>(<any>null);
    }
}

export class DocumentClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    contractDocuments(contractId: string, options: QueryOptions | null): Promise<PagedDataDtoOfDocumentDto | null> {
        let url_ = this.baseUrl + "/api/Document/{contractId}/reports";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processContractDocuments(_response);
        });
    }

    protected processContractDocuments(response: AxiosResponse): Promise<PagedDataDtoOfDocumentDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfDocumentDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfDocumentDto | null>(<any>null);
    }

    contractInvoices(contractId: string, options: QueryOptions | null): Promise<PagedDataDtoOfInvoiceDto | null> {
        let url_ = this.baseUrl + "/api/Document/{contractId}/invoices";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processContractInvoices(_response);
        });
    }

    protected processContractInvoices(response: AxiosResponse): Promise<PagedDataDtoOfInvoiceDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfInvoiceDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfInvoiceDto | null>(<any>null);
    }

    correctifCallDocuments(contractId: string, siteId: string, callId: string, options: QueryOptions | null): Promise<PagedDataDtoOfDocumentDto | null> {
        let url_ = this.baseUrl + "/api/Document/{contractId}/{siteId}/{callId}/correctif";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCorrectifCallDocuments(_response);
        });
    }

    protected processCorrectifCallDocuments(response: AxiosResponse): Promise<PagedDataDtoOfDocumentDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfDocumentDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfDocumentDto | null>(<any>null);
    }

    downloadContractDocument(documentId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/Download/Contract/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadContractDocument(_response);
        });
    }

    protected processDownloadContractDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    downloadContractInvoice(documentId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/Download/Invoice/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadContractInvoice(_response);
        });
    }

    protected processDownloadContractInvoice(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    downloadCorrectifCallDocument(documentId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/Download/Correctif/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadCorrectifCallDocument(_response);
        });
    }

    protected processDownloadCorrectifCallDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    downloadPreventCallDocument(documentId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/Download/Prevent/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadPreventCallDocument(_response);
        });
    }

    protected processDownloadPreventCallDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    preventifCallDocuments(contractId: string, siteId: string, callId: string, options: QueryOptions | null): Promise<PagedDataDtoOfDocumentDto | null> {
        let url_ = this.baseUrl + "/api/Document/{contractId}/{siteId}/{callId}/prevents";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPreventifCallDocuments(_response);
        });
    }

    protected processPreventifCallDocuments(response: AxiosResponse): Promise<PagedDataDtoOfDocumentDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfDocumentDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfDocumentDto | null>(<any>null);
    }

    getAllTypes(): Promise<DocumentTypeDto[] | null> {
        let url_ = this.baseUrl + "/api/Document/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllTypes(_response);
        });
    }

    protected processGetAllTypes(response: AxiosResponse): Promise<DocumentTypeDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTypeDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentTypeDto[] | null>(<any>null);
    }
}

export class ObjectsClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    getObjects(contractId: string, siteId: string, options: QueryOptions | null): Promise<PagedDataDtoOfObjectDto | null> {
        let url_ = this.baseUrl + "/api/Objects/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetObjects(_response);
        });
    }

    protected processGetObjects(response: AxiosResponse): Promise<PagedDataDtoOfObjectDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfObjectDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfObjectDto | null>(<any>null);
    }

    getObjectsByContratSite(contractId: string, siteId: string): Promise<ObjectDto[] | null> {
        let url_ = this.baseUrl + "/api/Objects/all/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetObjectsByContratSite(_response);
        });
    }

    protected processGetObjectsByContratSite(response: AxiosResponse): Promise<ObjectDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObjectDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ObjectDto[] | null>(<any>null);
    }

    getById(contractId: string, siteId: string, objectId: string): Promise<ObjectDto | null> {
        let url_ = this.baseUrl + "/api/Objects/{contractId}/{siteId}/{objectId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (objectId === undefined || objectId === null)
            throw new Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ObjectDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ObjectDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ObjectDto | null>(<any>null);
    }
}

export class RequestClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    sendRequest(elcoRequest: RequestDto | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Request/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(elcoRequest);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendRequest(_response);
        });
    }

    protected processSendRequest(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    upload(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/Request/Upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export class SitesClient extends ElcoBaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    get(contractId: string, options: QueryOptions | null): Promise<PagedDataDtoOfSiteDto | null> {
        let url_ = this.baseUrl + "/api/Sites/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PagedDataDtoOfSiteDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedDataDtoOfSiteDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedDataDtoOfSiteDto | null>(<any>null);
    }

    getById(contractId: string, siteId: string): Promise<SiteDto | null> {
        let url_ = this.baseUrl + "/api/Sites/{contractId}/{siteId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SiteDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SiteDto.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteDto | null>(<any>null);
    }

    getByContrat(contractId: string): Promise<SiteDto[] | null> {
        let url_ = this.baseUrl + "/api/Sites/all/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetByContrat(_response);
        });
    }

    protected processGetByContrat(response: AxiosResponse): Promise<SiteDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteDto[] | null>(<any>null);
    }
}

export class PagedDataDtoOfPreventCallDto implements IPagedDataDtoOfPreventCallDto {
    data?: PreventCallDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfPreventCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new PreventCallDto(item) : <PreventCallDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PreventCallDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfPreventCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfPreventCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfPreventCallDto {
    data?: IPreventCallDto[] | null;
    page: number;
    totalCount: number;
}

export class PreventCallDto implements IPreventCallDto {
    actionDateTime!: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    contractId?: string | null;
    followUp!: number;
    followUpReason?: string | null;
    hasDocuments!: boolean;
    initialObjectId?: string | null;
    objectId?: string | null;
    status?: string | null;
    visitDate?: moment.Moment | null;
    visitDescription?: string | null;
    visitScheduleid?: string | null;
    workOrder?: string | null;
    siteId?: string | null;

    constructor(data?: IPreventCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDateTime = _data["actionDateTime"] ? moment(_data["actionDateTime"].toString()) : <any>null;
            this.callId = _data["callId"] !== undefined ? _data["callId"] : <any>null;
            this.callSubject = _data["callSubject"] !== undefined ? _data["callSubject"] : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.followUp = _data["followUp"] !== undefined ? _data["followUp"] : <any>null;
            this.followUpReason = _data["followUpReason"] !== undefined ? _data["followUpReason"] : <any>null;
            this.hasDocuments = _data["hasDocuments"] !== undefined ? _data["hasDocuments"] : <any>null;
            this.initialObjectId = _data["initialObjectId"] !== undefined ? _data["initialObjectId"] : <any>null;
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>null;
            this.visitDescription = _data["visitDescription"] !== undefined ? _data["visitDescription"] : <any>null;
            this.visitScheduleid = _data["visitScheduleid"] !== undefined ? _data["visitScheduleid"] : <any>null;
            this.workOrder = _data["workOrder"] !== undefined ? _data["workOrder"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
        }
    }

    static fromJS(data: any): PreventCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreventCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDateTime"] = this.actionDateTime ? this.actionDateTime.toISOString() : <any>null;
        data["callId"] = this.callId !== undefined ? this.callId : <any>null;
        data["callSubject"] = this.callSubject !== undefined ? this.callSubject : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["followUp"] = this.followUp !== undefined ? this.followUp : <any>null;
        data["followUpReason"] = this.followUpReason !== undefined ? this.followUpReason : <any>null;
        data["hasDocuments"] = this.hasDocuments !== undefined ? this.hasDocuments : <any>null;
        data["initialObjectId"] = this.initialObjectId !== undefined ? this.initialObjectId : <any>null;
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>null;
        data["visitDescription"] = this.visitDescription !== undefined ? this.visitDescription : <any>null;
        data["visitScheduleid"] = this.visitScheduleid !== undefined ? this.visitScheduleid : <any>null;
        data["workOrder"] = this.workOrder !== undefined ? this.workOrder : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        return data; 
    }
}

export interface IPreventCallDto {
    actionDateTime: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    contractId?: string | null;
    followUp: number;
    followUpReason?: string | null;
    hasDocuments: boolean;
    initialObjectId?: string | null;
    objectId?: string | null;
    status?: string | null;
    visitDate?: moment.Moment | null;
    visitDescription?: string | null;
    visitScheduleid?: string | null;
    workOrder?: string | null;
    siteId?: string | null;
}

export class QueryOptions implements IQueryOptions {
    pageSize!: number;
    pageNumber!: number;
    search?: string | null;
    orderByField?: string | null;
    orderDirection?: string | null;
    filters?: FieldFilter[] | null;
    selectedRow?: string | null;
    cultureInfo?: string | null;

    constructor(data?: IQueryOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new FieldFilter(item) : <FieldFilter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.search = _data["search"] !== undefined ? _data["search"] : <any>null;
            this.orderByField = _data["orderByField"] !== undefined ? _data["orderByField"] : <any>null;
            this.orderDirection = _data["orderDirection"] !== undefined ? _data["orderDirection"] : <any>null;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FieldFilter.fromJS(item));
            }
            this.selectedRow = _data["selectedRow"] !== undefined ? _data["selectedRow"] : <any>null;
            this.cultureInfo = _data["cultureInfo"] !== undefined ? _data["cultureInfo"] : <any>null;
        }
    }

    static fromJS(data: any): QueryOptions {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["search"] = this.search !== undefined ? this.search : <any>null;
        data["orderByField"] = this.orderByField !== undefined ? this.orderByField : <any>null;
        data["orderDirection"] = this.orderDirection !== undefined ? this.orderDirection : <any>null;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["selectedRow"] = this.selectedRow !== undefined ? this.selectedRow : <any>null;
        data["cultureInfo"] = this.cultureInfo !== undefined ? this.cultureInfo : <any>null;
        return data; 
    }
}

export interface IQueryOptions {
    pageSize: number;
    pageNumber: number;
    search?: string | null;
    orderByField?: string | null;
    orderDirection?: string | null;
    filters?: IFieldFilter[] | null;
    selectedRow?: string | null;
    cultureInfo?: string | null;
}

export class FieldFilter implements IFieldFilter {
    field?: string | null;
    values?: string[] | null;

    constructor(data?: IFieldFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): FieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FieldFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field !== undefined ? this.field : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data; 
    }
}

export interface IFieldFilter {
    field?: string | null;
    values?: string[] | null;
}

export class PagedDataDtoOfCorrectionCallDto implements IPagedDataDtoOfCorrectionCallDto {
    data?: CorrectionCallDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfCorrectionCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CorrectionCallDto(item) : <CorrectionCallDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CorrectionCallDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfCorrectionCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfCorrectionCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfCorrectionCallDto {
    data?: ICorrectionCallDto[] | null;
    page: number;
    totalCount: number;
}

export class CorrectionCallDto implements ICorrectionCallDto {
    actionDateTime!: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    contractId?: string | null;
    followUp!: number;
    followUpReason?: string | null;
    hasDocuments!: boolean;
    initialObjectId?: string | null;
    objectId?: string | null;
    status?: string | null;
    visitDate?: moment.Moment | null;
    visitDescription?: string | null;
    visitScheduleId?: string | null;
    workOrder?: string | null;
    siteid?: string | null;

    constructor(data?: ICorrectionCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDateTime = _data["actionDateTime"] ? moment(_data["actionDateTime"].toString()) : <any>null;
            this.callId = _data["callId"] !== undefined ? _data["callId"] : <any>null;
            this.callSubject = _data["callSubject"] !== undefined ? _data["callSubject"] : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.followUp = _data["followUp"] !== undefined ? _data["followUp"] : <any>null;
            this.followUpReason = _data["followUpReason"] !== undefined ? _data["followUpReason"] : <any>null;
            this.hasDocuments = _data["hasDocuments"] !== undefined ? _data["hasDocuments"] : <any>null;
            this.initialObjectId = _data["initialObjectId"] !== undefined ? _data["initialObjectId"] : <any>null;
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>null;
            this.visitDescription = _data["visitDescription"] !== undefined ? _data["visitDescription"] : <any>null;
            this.visitScheduleId = _data["visitScheduleId"] !== undefined ? _data["visitScheduleId"] : <any>null;
            this.workOrder = _data["workOrder"] !== undefined ? _data["workOrder"] : <any>null;
            this.siteid = _data["siteid"] !== undefined ? _data["siteid"] : <any>null;
        }
    }

    static fromJS(data: any): CorrectionCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorrectionCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDateTime"] = this.actionDateTime ? this.actionDateTime.toISOString() : <any>null;
        data["callId"] = this.callId !== undefined ? this.callId : <any>null;
        data["callSubject"] = this.callSubject !== undefined ? this.callSubject : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["followUp"] = this.followUp !== undefined ? this.followUp : <any>null;
        data["followUpReason"] = this.followUpReason !== undefined ? this.followUpReason : <any>null;
        data["hasDocuments"] = this.hasDocuments !== undefined ? this.hasDocuments : <any>null;
        data["initialObjectId"] = this.initialObjectId !== undefined ? this.initialObjectId : <any>null;
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>null;
        data["visitDescription"] = this.visitDescription !== undefined ? this.visitDescription : <any>null;
        data["visitScheduleId"] = this.visitScheduleId !== undefined ? this.visitScheduleId : <any>null;
        data["workOrder"] = this.workOrder !== undefined ? this.workOrder : <any>null;
        data["siteid"] = this.siteid !== undefined ? this.siteid : <any>null;
        return data; 
    }
}

export interface ICorrectionCallDto {
    actionDateTime: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    contractId?: string | null;
    followUp: number;
    followUpReason?: string | null;
    hasDocuments: boolean;
    initialObjectId?: string | null;
    objectId?: string | null;
    status?: string | null;
    visitDate?: moment.Moment | null;
    visitDescription?: string | null;
    visitScheduleId?: string | null;
    workOrder?: string | null;
    siteid?: string | null;
}

export class PagedDataDtoOfPlannedMaintenanceDto implements IPagedDataDtoOfPlannedMaintenanceDto {
    data?: PlannedMaintenanceDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfPlannedMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new PlannedMaintenanceDto(item) : <PlannedMaintenanceDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlannedMaintenanceDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfPlannedMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfPlannedMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfPlannedMaintenanceDto {
    data?: IPlannedMaintenanceDto[] | null;
    page: number;
    totalCount: number;
}

export class PlannedMaintenanceDto implements IPlannedMaintenanceDto {
    visitDescription?: string | null;
    objectId?: string | null;
    objectName?: string | null;

    constructor(data?: IPlannedMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitDescription = _data["visitDescription"] !== undefined ? _data["visitDescription"] : <any>null;
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.objectName = _data["objectName"] !== undefined ? _data["objectName"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitDescription"] = this.visitDescription !== undefined ? this.visitDescription : <any>null;
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["objectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        return data; 
    }
}

export interface IPlannedMaintenanceDto {
    visitDescription?: string | null;
    objectId?: string | null;
    objectName?: string | null;
}

export class PagedDataDtoOfHistoricCallDto implements IPagedDataDtoOfHistoricCallDto {
    data?: HistoricCallDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfHistoricCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new HistoricCallDto(item) : <HistoricCallDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(HistoricCallDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfHistoricCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfHistoricCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfHistoricCallDto {
    data?: IHistoricCallDto[] | null;
    page: number;
    totalCount: number;
}

export class HistoricCallDto implements IHistoricCallDto {
    actionDateTime!: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    workOrder?: string | null;
    objectId?: string | null;
    status?: string | null;
    followUp?: string | null;
    followUpReason?: string | null;

    constructor(data?: IHistoricCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDateTime = _data["actionDateTime"] ? moment(_data["actionDateTime"].toString()) : <any>null;
            this.callId = _data["callId"] !== undefined ? _data["callId"] : <any>null;
            this.callSubject = _data["callSubject"] !== undefined ? _data["callSubject"] : <any>null;
            this.workOrder = _data["workOrder"] !== undefined ? _data["workOrder"] : <any>null;
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.followUp = _data["followUp"] !== undefined ? _data["followUp"] : <any>null;
            this.followUpReason = _data["followUpReason"] !== undefined ? _data["followUpReason"] : <any>null;
        }
    }

    static fromJS(data: any): HistoricCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDateTime"] = this.actionDateTime ? this.actionDateTime.toISOString() : <any>null;
        data["callId"] = this.callId !== undefined ? this.callId : <any>null;
        data["callSubject"] = this.callSubject !== undefined ? this.callSubject : <any>null;
        data["workOrder"] = this.workOrder !== undefined ? this.workOrder : <any>null;
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["followUp"] = this.followUp !== undefined ? this.followUp : <any>null;
        data["followUpReason"] = this.followUpReason !== undefined ? this.followUpReason : <any>null;
        return data; 
    }
}

export interface IHistoricCallDto {
    actionDateTime: moment.Moment;
    callId?: string | null;
    callSubject?: string | null;
    workOrder?: string | null;
    objectId?: string | null;
    status?: string | null;
    followUp?: string | null;
    followUpReason?: string | null;
}

export class StatusCallDto implements IStatusCallDto {
    id?: string | null;

    constructor(data?: IStatusCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): StatusCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }
}

export interface IStatusCallDto {
    id?: string | null;
}

export class FollowUpDto implements IFollowUpDto {
    description?: string | null;
    followup!: number;

    constructor(data?: IFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.followup = _data["followup"] !== undefined ? _data["followup"] : <any>null;
        }
    }

    static fromJS(data: any): FollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["followup"] = this.followup !== undefined ? this.followup : <any>null;
        return data; 
    }
}

export interface IFollowUpDto {
    description?: string | null;
    followup: number;
}

export class PagedDataDtoOfContractDto implements IPagedDataDtoOfContractDto {
    data?: ContractDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ContractDto(item) : <ContractDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContractDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfContractDto {
    data?: IContractDto[] | null;
    page: number;
    totalCount: number;
}

export class ContractDto implements IContractDto {
    customerId?: string | null;
    hasDocuments!: boolean;
    hasInvoices!: boolean;
    id?: string | null;
    name?: string | null;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.hasDocuments = _data["hasDocuments"] !== undefined ? _data["hasDocuments"] : <any>null;
            this.hasInvoices = _data["hasInvoices"] !== undefined ? _data["hasInvoices"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["hasDocuments"] = this.hasDocuments !== undefined ? this.hasDocuments : <any>null;
        data["hasInvoices"] = this.hasInvoices !== undefined ? this.hasInvoices : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IContractDto {
    customerId?: string | null;
    hasDocuments: boolean;
    hasInvoices: boolean;
    id?: string | null;
    name?: string | null;
}

export class PagedDataDtoOfDocumentDto implements IPagedDataDtoOfDocumentDto {
    data?: DocumentDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DocumentDto(item) : <DocumentDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfDocumentDto {
    data?: IDocumentDto[] | null;
    page: number;
    totalCount: number;
}

export class DocumentDto implements IDocumentDto {
    createddatetime!: moment.Moment;
    name?: string | null;
    recid!: number;
    typeid?: string | null;
    typeName?: string | null;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createddatetime = _data["createddatetime"] ? moment(_data["createddatetime"].toString()) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.recid = _data["recid"] !== undefined ? _data["recid"] : <any>null;
            this.typeid = _data["typeid"] !== undefined ? _data["typeid"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createddatetime"] = this.createddatetime ? this.createddatetime.toISOString() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["recid"] = this.recid !== undefined ? this.recid : <any>null;
        data["typeid"] = this.typeid !== undefined ? this.typeid : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface IDocumentDto {
    createddatetime: moment.Moment;
    name?: string | null;
    recid: number;
    typeid?: string | null;
    typeName?: string | null;
}

export class PagedDataDtoOfInvoiceDto implements IPagedDataDtoOfInvoiceDto {
    data?: InvoiceDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvoiceDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfInvoiceDto {
    data?: InvoiceDto[] | null;
    page: number;
    totalCount: number;
}

export class InvoiceDto extends DocumentDto implements IInvoiceDto {
    invoiceDate!: moment.Moment;
    invoiceAmount!: number;

    constructor(data?: IInvoiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>null;
            this.invoiceAmount = _data["invoiceAmount"] !== undefined ? _data["invoiceAmount"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>null;
        data["invoiceAmount"] = this.invoiceAmount !== undefined ? this.invoiceAmount : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IInvoiceDto extends IDocumentDto {
    invoiceDate: moment.Moment;
    invoiceAmount: number;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    id?: string | null;
    name?: string | null;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IDocumentTypeDto {
    id?: string | null;
    name?: string | null;
}

export class PagedDataDtoOfObjectDto implements IPagedDataDtoOfObjectDto {
    data?: ObjectDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ObjectDto(item) : <ObjectDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ObjectDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfObjectDto {
    data?: IObjectDto[] | null;
    page: number;
    totalCount: number;
}

export class ObjectDto implements IObjectDto {
    active?: boolean | null;
    description?: string | null;
    localization?: string | null;
    objectId?: string | null;
    objectQty!: number;
    objectType?: string | null;
    siteId?: string | null;
    contractId?: string | null;
    hasHistory!: boolean;

    constructor(data?: IObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.localization = _data["localization"] !== undefined ? _data["localization"] : <any>null;
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.objectQty = _data["objectQty"] !== undefined ? _data["objectQty"] : <any>null;
            this.objectType = _data["objectType"] !== undefined ? _data["objectType"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.hasHistory = _data["hasHistory"] !== undefined ? _data["hasHistory"] : <any>null;
        }
    }

    static fromJS(data: any): ObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["localization"] = this.localization !== undefined ? this.localization : <any>null;
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["objectQty"] = this.objectQty !== undefined ? this.objectQty : <any>null;
        data["objectType"] = this.objectType !== undefined ? this.objectType : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["hasHistory"] = this.hasHistory !== undefined ? this.hasHistory : <any>null;
        return data; 
    }
}

export interface IObjectDto {
    active?: boolean | null;
    description?: string | null;
    localization?: string | null;
    objectId?: string | null;
    objectQty: number;
    objectType?: string | null;
    siteId?: string | null;
    contractId?: string | null;
    hasHistory: boolean;
}

export class RequestDto implements IRequestDto {
    contract?: ContractDto | null;
    site?: SiteDto | null;
    object?: ObjectDto | null;
    connectedUserMail?: string | null;
    requester?: string | null;
    company?: string | null;
    phone?: string | null;
    mail?: string | null;
    reason?: string | null;
    attachmentFolderName?: string | null;

    constructor(data?: IRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.contract = data.contract && !(<any>data.contract).toJSON ? new ContractDto(data.contract) : <ContractDto>this.contract; 
            this.site = data.site && !(<any>data.site).toJSON ? new SiteDto(data.site) : <SiteDto>this.site; 
            this.object = data.object && !(<any>data.object).toJSON ? new ObjectDto(data.object) : <ObjectDto>this.object; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>null;
            this.site = _data["site"] ? SiteDto.fromJS(_data["site"]) : <any>null;
            this.object = _data["object"] ? ObjectDto.fromJS(_data["object"]) : <any>null;
            this.connectedUserMail = _data["connectedUserMail"] !== undefined ? _data["connectedUserMail"] : <any>null;
            this.requester = _data["requester"] !== undefined ? _data["requester"] : <any>null;
            this.company = _data["company"] !== undefined ? _data["company"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.mail = _data["mail"] !== undefined ? _data["mail"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.attachmentFolderName = _data["attachmentFolderName"] !== undefined ? _data["attachmentFolderName"] : <any>null;
        }
    }

    static fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["site"] = this.site ? this.site.toJSON() : <any>null;
        data["object"] = this.object ? this.object.toJSON() : <any>null;
        data["connectedUserMail"] = this.connectedUserMail !== undefined ? this.connectedUserMail : <any>null;
        data["requester"] = this.requester !== undefined ? this.requester : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["mail"] = this.mail !== undefined ? this.mail : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["attachmentFolderName"] = this.attachmentFolderName !== undefined ? this.attachmentFolderName : <any>null;
        return data; 
    }
}

export interface IRequestDto {
    contract?: IContractDto | null;
    site?: ISiteDto | null;
    object?: IObjectDto | null;
    connectedUserMail?: string | null;
    requester?: string | null;
    company?: string | null;
    phone?: string | null;
    mail?: string | null;
    reason?: string | null;
    attachmentFolderName?: string | null;
}

export class SiteDto implements ISiteDto {
    contractId?: string | null;
    id?: string | null;
    name?: string | null;
    hasHistory!: boolean;

    constructor(data?: ISiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.hasHistory = _data["hasHistory"] !== undefined ? _data["hasHistory"] : <any>null;
        }
    }

    static fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["hasHistory"] = this.hasHistory !== undefined ? this.hasHistory : <any>null;
        return data; 
    }
}

export interface ISiteDto {
    contractId?: string | null;
    id?: string | null;
    name?: string | null;
    hasHistory: boolean;
}

export class PagedDataDtoOfSiteDto implements IPagedDataDtoOfSiteDto {
    data?: SiteDto[] | null;
    page!: number;
    totalCount!: number;

    constructor(data?: IPagedDataDtoOfSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new SiteDto(item) : <SiteDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SiteDto.fromJS(item));
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedDataDtoOfSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataDtoOfSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }
}

export interface IPagedDataDtoOfSiteDto {
    data?: ISiteDto[] | null;
    page: number;
    totalCount: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}